import cruxAxios from 'app/cruxAxios'
import { LNB_ACCOUNT_SIZE } from '../../../features/lnb/lnbSlice'

/**
 * @file CRUX GATEWAY 계정 API
 * @see http://adp-account-sandbox.devel.kakao.com/swagger.html
 * @see https://wiki.daumkakao.com/x/8OxgHw
 * 기존 계정 API 앞에 다음 /crux-account/ path를 추가한다.
 */
const { get, put } = cruxAxios
export const searchAdAccounts = (searchKeyword = '', page = 0) =>
  searchKeyword.trim() === ''
    ? get('/crux-account/adAccounts:Page', {
        params: {
          userConfigs: 'ON,OFF',
          adPlatformTypes: 'KEYWORDAD',
          page,
          size: LNB_ACCOUNT_SIZE,
        },
      })
    : get('/crux-account/adAccountMembers:Page', {
        params: {
          userConfigs: 'ON,OFF',
          adPlatformTypes: 'KEYWORDAD',
          page,
          size: LNB_ACCOUNT_SIZE,
          searchKeyword,
          adAccountSearchType: 'AD_ACCOUNT_NAME',
          adAccountMemberStatuses: 'APPROVED,PENDING_MASTER',
        },
        paramsSerializer: {
          encode: value => encodeURIComponent(value),
        },
      })
export const getAdAccount = adAccountId =>
  get(`/crux-account/adAccounts/${adAccountId}`, {
    headers: {
      adAccountId,
    },
  })
export const putAdAccountOn = adAccountId =>
  put(`/crux-account/adAccounts/${adAccountId}/on`)
export const putAdAccountOff = adAccountId =>
  put(`/crux-account/adAccounts/${adAccountId}/off`)
